// import { ErrorMessage, Field, Form, Formik } from "formik";
import LoaderHelper from "../utility/Loading/LoaderHelper";
import AuthService from "../Api_Module/Api_Services/AuthService";
import { alertSuccessMessage, alertWarningMessage } from "../utility/CustomAlertMessage";
// import * as Yup from 'yup';
import { useNavigate, Link } from "react-router-dom";
import { useContext, useEffect, useState } from "react";
import { UserContext } from "../context/UserContext";
import GoogleLoginWrapper from "../components/GoogleLoginWrapper";
import { useTheme } from "../components/ThemeContext";

const Login = () => {
    const navigate = useNavigate();
    const { theme } = useTheme();
    const [subscriptionConfig, setSubscriptionConfig] = useState<any>(null);
    const userContext = useContext(UserContext);
    if (!userContext) {
        throw new Error("UserContext is not available");
    }
    const { getResearchData } = userContext;

    useEffect(() => {
        const authToken = sessionStorage.getItem("STOCK_AUTH_TOKEN");
        if (authToken) {
            navigate("/");
        }
        getSubscriptionConfig();
    }, [navigate]);

    const getSubscriptionConfig = async () => {
        try {
            const response = await AuthService.getSubscriptionConfig();
            if (response) {
                setSubscriptionConfig(response);
            }
        } catch (error) {
            console.error('Error fetching subscription config:', error);
        }
    };

    // Commented out manual login validation and handlers
    // const validationSchema = Yup.object({
    //     email: Yup.string().email('Invalid email address').required('Email is required'),
    //     password: Yup.string().min(6, 'Password must be at least 6 characters').required('Password is required'),
    // });

    // const handleSubmit = async (_values: { email: string; password: string }, { setSubmitting }: any) => {
    //     try {
    //         LoaderHelper.loaderStatus(true);
    //         const result = await AuthService.login(_values.email, _values.password);
    //         if (result?.token) {
    //             
    //             sessionStorage.setItem("STOCK_AUTH_TOKEN", result?.token);
    //             sessionStorage.setItem("userId", result?.userId);
    //             LoaderHelper.loaderStatus(false);
    //             alertSuccessMessage('Login Successfull !!');
    //             navigate("/");

    //         } 
    //     } catch (error) {
    //         LoaderHelper.loaderStatus(false);
    //         console.error('Login error:', error);
    //         alertWarningMessage('Login failed. Please check your credentials and try again.');
    //     } finally {
    //         setSubmitting(false);
    //     }
    // };

    const handleGoogleLoginSuccess = async (credentialResponse: any) => {
        try {
            console.log('Google Login Success:', credentialResponse);
            LoaderHelper.loaderStatus(true);
            const result = await AuthService.googleLogin(
                credentialResponse.credential,
                credentialResponse.userInfo // Pass the extracted user info
            );
            if (result?.token) {
                sessionStorage.setItem("STOCK_AUTH_TOKEN", result?.token);
                sessionStorage.setItem("userId", result?.userId);
                // Store additional user info if needed
                if (result.userProfile) {
                    sessionStorage.setItem("userProfile", JSON.stringify(result.userProfile));
                }
                LoaderHelper.loaderStatus(false);
                alertSuccessMessage('Login Successful!');
                navigate("/");
            }
        } catch (error) {
            LoaderHelper.loaderStatus(false);
            console.error('Google login error:', error);
            alertWarningMessage('Google login failed. Please try again.');
        }
    };

    return (
        <section className="py-16 md:py-14 bg-theme-primary">
            <div className="container mx-auto px-4">
                <div className="p-6 md:p-8 w-full max-w-md mx-auto bg-theme-secondary rounded-lg border border-theme-tertiary">
                    <h2 className="text-2xl font-bold mb-6 text-center text-theme-primary">Sign In</h2>

                    <div className={`p-4 rounded-lg mb-6 ${theme === 'dark' ? 'bg-green-900/20 border-green-500/30' : 'bg-green-50 border-green-200'} border`}>
                        <h3 className={`font-semibold mb-2 ${theme === 'dark' ? 'text-green-300' : 'text-green-700'}`}>
                            👋 Welcome Back
                        </h3>
                        <p className={`text-sm ${theme === 'dark' ? 'text-green-400' : 'text-green-600'}`}>
                            Access your account to continue using Stock Fortress
                        </p>
                    </div>

                    <GoogleLoginWrapper onSuccess={handleGoogleLoginSuccess} />

                    {/* Commented out manual login form */}
                    {/* <div className="flex items-center my-4">
                        <hr className="flex-grow border-theme-tertiary" />
                        <span className="px-3 text-theme-secondary">Or Sign In with Email</span>
                        <hr className="flex-grow border-theme-tertiary" />
                    </div>
                    <Formik
                        initialValues={{ email: '', password: '' }}
                        validationSchema={validationSchema}
                        onSubmit={handleSubmit}
                    >
                        {({ isSubmitting }) => (
                            <Form>
                                <div className="mb-4">
                                    <Field
                                        type="email"
                                        name="email"
                                        placeholder="Email"
                                        className="w-full p-2 border rounded-lg text-gray-700 focus:outline-none focus:ring-2 focus:ring-purple-500"
                                    />
                                    <ErrorMessage name="email" component="div" className="text-red-500 text-sm mt-1" />
                                </div>
                                <div className="mb-4">
                                    <Field
                                        type="password"
                                        name="password"
                                        placeholder="Password"
                                        className="w-full p-2 border rounded-lg text-gray-700 focus:outline-none focus:ring-2 focus:ring-purple-500"
                                    />
                                    <ErrorMessage name="password" component="div" className="text-red-500 text-sm mt-1" />
                                </div>
                                <button
                                    type="submit"
                                    disabled={isSubmitting}
                                    className="w-full py-2 bg-blue-600 text-theme-primary font-semibold rounded-lg hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-blue-500 transition duration-200"
                                >
                                    Sign In
                                </button>
                            </Form>
                        )}
                    </Formik> */}

                    <div className="mt-6 text-center">
                        <span className="text-theme-secondary">Don't have an account? </span>
                        <button
                            onClick={() => navigate("/signup")}
                            className="text-blue-600 hover:text-blue-800 font-medium"
                        >
                            Sign Up
                        </button>
                    </div>

                    <div className={`mt-6 p-3 rounded-lg text-xs ${theme === 'dark' ? 'bg-theme-secondary text-theme-muted' : 'bg-gray-100 text-gray-600'}`}>
                        <p className="mb-1"><strong>New to Stock Fortress?</strong></p>
                        <ul className="list-disc list-inside space-y-1 ml-2">
                            <li>Professional stock analysis tools</li>
                            <li>Real-time market insights</li>
                            <li>Advanced portfolio tracking</li>
                            <li>Comprehensive market data</li>
                        </ul>
                    </div>
                </div>
            </div>
        </section>
    );
};

export default Login;
